package components.company.pricelist.tables

import components.company.pricelist.dataSheetLink
import components.company.pricelist.priceListExportHeading
import it.neckar.lizergy.model.price.PriceListExportCategory
import it.neckar.open.collections.fastForEach
import it.neckar.open.collections.fastForEachIndexed
import kotlinx.html.ThScope
import plannerI18nConfiguration
import react.*
import react.dom.*
import store.hooks.useSelectPriceList
import style.toStyleClass

val HybridInverterPriceTable: FC<Props> = fc("HybridInverterPriceTable") {
  val priceList = useSelectPriceList()

  val hybridInverterPrices = priceList.hybridInverterPrices


  div("col") {
    priceListExportHeading(PriceListExportCategory.HybridInverters)

    table("table table-responsive table-striped") {
      thead {
        tr {
          th(ThScope.col) {
            +"#"
          }
          th(ThScope.col) {
            +"Name"
          }
          th(ThScope.col) {
            +"Hersteller"
          }
          th(ThScope.col) {
            +"Leistung"
          }
          th(ThScope.col) {
            +"MPP-Eingänge"
          }
          th(ThScope.col, "text-end") {
            +"Kosten"
          }
          th(ThScope.col, "text-end") {
            +"Preis"
          }

          th(ThScope.col) { }
        }
      }

      tbody {
        hybridInverterPrices.available.fastForEachIndexed { inverterIndex, inverter ->
          tr(classes = inverter.lifeCycleState.toStyleClass()) {
            key = inverter.uuid.toString()

            th(ThScope.row) {
              +(inverterIndex + 1).toString()
            }
            td {
              +inverter.description
            }
            td {
              +inverter.manufacturer.name
            }
            td {
              +inverter.capacity.format(plannerI18nConfiguration)
            }
            td {
              inverter.mppInputs.fastForEach { p { +it.format() } }
            }

            td("text-end") {
              +hybridInverterPrices[inverter].inputPrice.format()
            }
            td("text-end") {
              +hybridInverterPrices[inverter].sellingPrice.format()
            }

            td("text-center") {
              inverter.dataSheetPath?.let { dataSheetLink(it) }
            }
          }
        }
      }
    }
  }

}
